import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

import MenuItem from '@material-ui/core/MenuItem';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import { inject, observer } from 'mobx-react';
import Moment from 'moment';
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';

import { sendToSalesFlow, setDigitalData } from '../../Utilities/Utils.js';

import './EnterPass.css';


const theme = createMuiTheme({
    palette: {
        primary: {
            light: "#3CB6CE",
            main: "#3CB6CE",
            dark: "#3CB6CE",
            contrastText: "#3CB6CE"
        },
        text: {
            primary:"white" ,
            secondary: "white"
        },
        action: {
            active:"white"
        }
    },
    typography : {
        fontFamily: ['Roboto Condensed','Roboto','Helvetica'].join(','),
        fontSize: "20",
    }
    
});

const styles = {
    resize:{
    },
    labelResize:{
    },
    menuItem:{
        color:'black',
    },
    underline: {
        color: theme.palette.common.white,
        borderBottom: theme.palette.common.white,
        '&:after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:focused::after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:before': {
            borderBottom: `1px solid ${theme.palette.common.white}`,
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
            borderBottom: '2px solid rgb(255, 255, 255) !important',
        },
        '&$disabled:before': {
            borderBottom: `1px dotted ${theme.palette.common.white}`,
        },
	},
    disabled: {},
    focused: {},
    error: {}
}


class DGREnterPass extends Component {
    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
        this.props.DGRStore.values.is_waiver_signed = false;
        this.props.DGRStore.values.is_expired = false;
        this.props.DGRStore.values.is_guest = false;
        this.props.DGRStore.values.days_left = 0;
        setDigitalData( ( this.props.DGRStore.values.membership_flow ? 'join matchback' : 'guest registration' ), this.props.DGRStore.club_number );
    }


    handleChange = (e) => {
        this.props.DGRStore.setValue(e.target.name,e.target.value);
    }

    hideIfCostcoCorporate( otherClass ) {
        if ( !otherClass ) otherClass = '';
        if ( this.props.DGRStore.values.membership_flow && [ 'costco', 'corporate' ].indexOf( this.props.DGRStore.club_product_id ) > -1 ) {
            return otherClass + ' hideme';
        } else {
            return otherClass;
        }
    }

    // When searching by first name, last name, and birthday.
    handleSubmitUserCreds = (e) => {
        // First, make sure they entered a valid birthday.
        var year = this.props.DGRStore.values.year,
            month = ( this.props.DGRStore.values.month + 1 ),
            day = this.props.DGRStore.values.day,
            datestr = '' + year + '-' + ( month < 10 ? '0' : '' ) + month + '-' + ( day < 10 ? '0' : '' ) + day,
            date = Moment( datestr );

        if ( !date.isValid() ) {
            alert('Please enter a valid Date of Birth.');
            e.preventDefault();
            return false;
        }

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Enter Pass',
            action: 'Matchback Form'
        });

        this.props.DGRStore.enterPassUserCreds()
        .then( response => {
            //TODO 
            //move all this to function, or not since guest pass is slightly different
            //also think of centralized routing 
            const { club_product_id, club_number } = this.props.DGRStore;
            const { is_expired, is_waiver_signed, lead_number, is_guest, membership_flow } = this.props.DGRStore.values;

            // We couldn't find their information, so create a new lead.
            if ( !lead_number ){
                //figure out if no pass found error or network failure
                if ( membership_flow ) {
                    this.props.history.push('lead');
                } else {
                    this.props.history.push('create_pass');
                }
                return
            }
            // If this lead had an MVM, but expired, (and not in the purchasing flow) then show that screen.
            if ( is_expired && !membership_flow ){
                this.props.history.push('return_visit');
                return
            }
            // If the lead exists but no waiver signed, then take them to that screen.
            if ( !is_waiver_signed ){
                this.props.history.push('sign_waiver');
                return
            }
            // At this point, we know we have an existing lead that signed the waiver.
            // So take them into the sales flow if that's where they were going.
            if ( membership_flow && club_product_id ) {
                sendToSalesFlow( club_product_id, club_number, this.props.DGRStore.values );
                return;
            }
            // If they have an active MVM, take them to the
            // return visit screen showing the number of days left.
            if ( is_guest ){
                this.props.history.push('return_visit');
                return
            }
            // We got a lead number, so it was just created
            this.props.history.push('first_visit');
        })
    }
    handleSubmitGuestPass = (e) => {

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Enter Pass',
            action: 'Pass Code Form Submit',
            label: this.props.DGRStore.values.guestPass
        });

        this.props.DGRStore.enterPassGuestPass()
        .then( () => {
            const { is_expired, is_waiver_signed, lead_number, is_guest, membership_flow } = this.props.DGRStore.values;
            const { club_product_id, club_number, errors } = this.props.DGRStore;
            if ( errors ){

                ReactGA.set({ dimension7: new Date().getTime() });
                ReactGA.event({
                    category: 'Enter Pass',
                    action: 'Pass Code Form Error',
                    label: this.props.DGRStore.values.guestPass
                });

                this.props.DGRModalStore.setSection('passNotFound')
				this.props.DGRModalStore.setCloseVisible()
                this.props.DGRModalStore.openModal()
                return
            }

            ReactGA.set({ dimension7: new Date().getTime() });
            ReactGA.event({
                category: 'Enter Pass',
                action: 'Pass Code Form Success',
                label: this.props.DGRStore.values.guestPass
            });

            // If this lead had an MVM, but expired, (and not in the purchasing flow) then show that screen.
            if ( is_expired && !membership_flow ){
                this.props.history.push('return_visit');
                return
            }
            // If the lead exists but no waiver signed, then take them to that screen.
            if ( !is_waiver_signed ){
                this.props.history.push('sign_waiver');
                return
            }
            // At this point, we know we have an existing lead that signed the waiver.
            // So take them into the sales flow if that's where they were going.
            if ( membership_flow && club_product_id ) {
                sendToSalesFlow( club_product_id, club_number, this.props.DGRStore.values );
                return;
            }
            if ( is_guest ){
                this.props.history.push('return_visit');
                return
            }
            if ( lead_number ) {
                this.props.history.push('first_visit');
            }
        })
    }

    render(){
        const { classes } = this.props;

        const { first_name, last_name, year, day, month, guestPass } = this.props.DGRStore.values;

        const fillRange = (start, end) => {
            return Array(end - start + 1).fill().map((item, index) => start + index);
        };


        const daysArray = fillRange(1, 31);
        const days = daysArray.map( (day, i ) => {
            return ( 
                <MenuItem 
                    classes={{
                        root: classes.menuItem 
                      }}
                    key={i}
                    value={day}
                 >{day}</MenuItem>
            ); 
        })
        const monthsArray = fillRange(0, 11);
        const months = monthsArray.map( (month, i) => {
            var momentInstance = Moment
            const monthName = momentInstance.months(i)
            return (
                <MenuItem 
                    classes={{
                        root: classes.menuItem 
                      }}
                    key={i} 
                    value={i}
                 >{monthName}</MenuItem>   
            )
        })
        var yearsArray = fillRange( ( new Date().getFullYear() - 100 ), new Date().getFullYear() );
        yearsArray = yearsArray.reverse()
        const years = yearsArray.map( (year, i ) => {
            return ( 
                <MenuItem 
                    classes={{
                        root: classes.menuItem 
                      }}
                    className="year" 
                    key={i} value={year}
                    >{year}
                </MenuItem>
            ); 
        })

        return(
            <Fade>
            <div className="enterPass">
                <MuiThemeProvider theme={theme}>

                <div className="enterPassTitleText">
                    <h2>Enter your information below</h2>
                </div>

                <div className="enterPassTitleSubText">
                    <div className="subText">
                         Photo identification required.  If under 18 years of age, a parent or guardian must be present.
                    </div>
                </div>

                <div className="enterPassItems">  
                    <ValidatorForm
                        className="userPass"
                        ref="form"
                        autoComplete="off"
                        instantValidate = {false}
                        onSubmit={this.handleSubmitUserCreds}
                        onError={errors => console.log(errors)}
                    >
                        <TextValidator
                            key="0"
                            label="First Name"
                            onChange={this.handleChange}
                            className="name"
                            placeholder="eg: John"
                            name="first_name"
                            InputProps={{
                                classes: {
                                    input: classes.resize,
                                    underline: classes.underline
                                },
                            }}
                            InputLabelProps={{
                                classes: {
                                    root: classes.labelResize,
                                },
                            }}
                            value={first_name}
                            validators={['required','matchRegexp:^([^0-9]*)$']}
                            errorMessages={['This field is required', 'No numbers allowed']}
                            margin="normal"
                        />
                        <TextValidator
                            label="Last Name"
                            onChange={this.handleChange}
                            name="last_name"
                            className="name"
                            placeholder="eg: Smith"
                            InputProps={{
                                classes: {
                                    input: classes.resize,
                                    underline: classes.underline
                                },
                            }}
                            InputLabelProps={{
                                classes: {
                                    root: classes.labelResize,
                                },
                            }}
                            value={last_name}
                            validators={['required','matchRegexp:^([^0-9]*)$']}
                            errorMessages={['This field is required', 'No numbers allowed']}
                            margin="normal"
                        />
                        <div className='birthday' >Date of Birth</div>
                        <SelectValidator
                            name="year"
                            className="birthdaySel"
                            value={year}
                            onChange={this.handleChange}
                            InputProps={{
                                classes: {
                                    underline: classes.underline,
                                },
                                name: 'year',
                                id: 'year',
                            }}
                        >
                            {years}
                        </SelectValidator> 
                        <SelectValidator
                            name="month"
                            className="birthdaySel"
                            value={month}
                            onChange={this.handleChange}
                            InputProps={{
                                classes: {
                                    underline: classes.underline
                                },
                                name: 'month',
                                id: 'month',
                            }}
                        >
                            {months}
                        </SelectValidator> 
                        <SelectValidator
                            name="day"
                            className="birthdaySel"
                            value={day}
                            onChange={this.handleChange}
                            InputProps={{
                                classes: {
                                    underline: classes.underline
                                },
                                name: 'day',
                                id: 'day',
                            }}
                        >
                            {days}
                        </SelectValidator> 
                        <br/>
                        <div className="continueBtn">
                            <button className="bigButton" type="submit">Continue</button>
                        </div>
                    </ValidatorForm>

                    <div className={ this.hideIfCostcoCorporate('orSection') }>
                        <h2>
                        OR
                        </h2>
                    </div>
            
                    <ValidatorForm
                        autoComplete="off"
                        className={ this.hideIfCostcoCorporate('guestPass') }
                        ref="form"
                        instantValidate = {false}
                        onSubmit={this.handleSubmitGuestPass }
                        onError={errors => console.log(errors)}
                    >
                        <TextValidator
                            label="Web Confirmation Code"
                            onChange={this.handleChange}
                            className="guestPassField"
                            name="guestPass"
                            InputProps={{
                                classes: {
                                    //input: classes.resize,
                                    underline: classes.underline
                                },
                            }}
                            
                            value={guestPass}
                            validators={['required']}
                            errorMessages={['This field is required']}
                        />
                        <div className="continueBtn">
                        <button className="bigButton" type="submit">Continue</button>

                        </div>
                    </ValidatorForm>
            </div>
             </MuiThemeProvider>
            </div>
            </Fade>
        )
    }
}

DGREnterPass = inject('DGRBackgroundStore','DGRStore','DGRModalStore')(observer(DGREnterPass ))    

//export default DGREnterPass;
export default withStyles(styles)(DGREnterPass);





// WEBPACK FOOTER //
// ./src/components/DGR/EnterPass/EnterPass.js